import {createContext} from "react";

const SiderBarContext = createContext({})

export default SiderBarContext;
